var project = require('../../settings');
var utils = require('./modules/utils');

/* Event Handlers  */
(function ($, $PB) {

    // Automatically equalize height on specified elements
    $(window).on("load", function () {
        utils.equalHeight('.equal');
        $(window).trigger('resize').trigger('scroll');

        setInterval(function() {
            jQuery(window).trigger('resize').trigger('scroll');

        }, 1000);
    });

    $("#menu-wrapper").mmenu(
        {
            "navbar": {
                "title": mmtitle,
            },
            "navbars": [
                {
                    "position": "bottom",
                    "content": [
                        "searchfield"
                    ]
                }
            ],
            "extensions": [
                "pagedim-black",
                "theme-dark",
                "position-right"
            ],
            "searchfield": {
                "search": false,
            },
            classNames: {
                fixedElements: {
                    fixed: "fix",
                    sticky: "stick"
                }
            }
        }, {
            "searchfield": {
                "form": {
                    "method": 'GET',
                    "action": homeurl
                },
                "input": {
                    "name": 's'
                }
            },
            offCanvas: {
                page: {
                    selector: "#site-page"
                }
            },
        }
    );

    $( document ).ready(function() {
        $('.builder-layout-full-width-masonry-grid .block-wrap').show();
        $('.builder-component-image-grid .block-wrap').show();
    });

    $('.builder-layout-half-block .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    $('.builder-layout-rollover-section .rollover').each(function () {
        if ($(this).siblings('.rollover-active').length) {
            $(this).addClass('has-active');
        }
    });

    // Header Reservation Menu

    $('#reserve').hover(function(){
       $('.res-container').css("display", "inline-block");
    }, function(){
        $('.res-container').css("display", "none");
    }
    );

    //menu navigation
    $('.dinner-tab').click(function() {
        $('.dinner-tab').addClass('active');
        $('.drinks-tab').removeClass('active');
        $('.happy-tab').removeClass('active');
        $('.brunch-tab').removeClass('active');

        $('.menu--dinnerMenu').addClass('active-menu');
        $('.menu--drinksMenu').removeClass('active-menu');
        $('.menu--happyMenu').removeClass('active-menu');
        $('.menu--brunchMenu').removeClass('active-menu');
    });

    $('.drinks-tab').click(function() {
        $('.drinks-tab').addClass('active');
        $('.dinner-tab').removeClass('active');
        $('.happy-tab').removeClass('active');
        $('.brunch-tab').removeClass('active');

        $('.menu--drinksMenu').addClass('active-menu');
        $('.menu--dinnerMenu').removeClass('active-menu');
        $('.menu--happyMenu').removeClass('active-menu');
        $('.menu--brunchMenu').removeClass('active-menu');
    });

    $('.happy-tab').click(function() {
        $('.happy-tab').addClass('active');
        $('.dinner-tab').removeClass('active');
        $('.drinks-tab').removeClass('active');
        $('.brunch-tab').removeClass('active');

        $('.menu--happyMenu').addClass('active-menu');
        $('.menu--drinksMenu').removeClass('active-menu');
        $('.menu--dinnerMenu').removeClass('active-menu');
        $('.menu--brunchMenu').removeClass('active-menu');
    });
    $('.brunch-tab').click(function() {
        $('.brunch-tab').addClass('active');
        $('.happy-tab').removeClass('active');
        $('.dinner-tab').removeClass('active');
        $('.drinks-tab').removeClass('active');

        $('.menu--brunchMenu').addClass('active-menu');
        $('.menu--happyMenu').removeClass('active-menu');
        $('.menu--drinksMenu').removeClass('active-menu');
        $('.menu--dinnerMenu').removeClass('active-menu');
    });


    $('.tabs-container ul.tabs-wrap li:first-child').addClass('open');
    $('.tab-outer-wrap .tab-content:first-child').addClass('open');

    $('.tabs-container ul.tabs-wrap li').on('click', function(){
        var $tab_id = $(this).attr('data-tab');

        $('.tabs-container ul.tabs-wrap li').removeClass('open');
        $('.tab-content').removeClass('open');

        $(this).addClass('open');
        $("#"+$tab_id).addClass('open');

    });


    //Tab Box JS
    $('.builder-layout-tab-layout .tab').on('click', function () {
        var num = $(this).attr('data-tab');
        var $parent = $(this).parents('.builder-layout');
        var $tabs = $parent.find('.builder-tabs');
        var $content = $parent.find('.builder-tabs--content');

        $content.find('.tab--content').removeClass('active').addClass('off');
        $content.find('[data-tab="' + num + '"]').addClass('active').removeClass('off');

        $tabs.find('.overtab').removeClass('active').addClass('off');
        $(this).parents('.overtab').addClass('active').removeClass('off');
    });

})(jQuery, KMDGPB.jQuery);